import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { SuperAdminIcon } from "./SuperAdminIcon.js";
import "react";
import { Avatar } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserListItem.tsx
var UserListItem = ({ userData }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "inline-flex w-full justify-start",
		children: [/* @__PURE__ */ jsx("div", {
			className: "flex flex-col justify-center",
			children: /* @__PURE__ */ jsx(Avatar, {
				url: getTHERMSImageThumbnailUrl(userData.user.avatarUrl),
				circular: true,
				statusColor: userData.user.status?.color
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "inline-flex w-full justify-between",
			children: [/* @__PURE__ */ jsx("div", {
				className: "mx-base",
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex flex-col items-start",
					children: [
						/* @__PURE__ */ jsx("small", {
							className: "text-color-subtle truncate text-sm font-bold",
							children: userData.organization.name
						}),
						/* @__PURE__ */ jsx("span", {
							className: "truncate",
							children: userData.user.displayName
						}),
						/* @__PURE__ */ jsx("small", {
							className: "text-color-subtle truncate text-sm font-light",
							children: userData.user?.title
						})
					]
				})
			}), /* @__PURE__ */ jsx("div", {
				className: "flex justify-center",
				children: userData.user.superAdmin && /* @__PURE__ */ jsx(SuperAdminIcon, {})
			})]
		})]
	});
};
//#endregion
export { UserListItem };

//# sourceMappingURL=UserListItem.js.map